import { Link, useParams } from "react-router-dom"; // Import useParams
import {
    useGetEmployerQuery,
} from "../store/apiSlice";
import { useGetAllUsersQuery } from "./auth/authApiSlice";
import EmployerAddEdit from "./EmployerAddEdit";

// ActionLink helper component (no changes needed here)
const ActionLink = ({ to, isEnabled, children }) => {
    const baseClasses = "flex-grow sm:flex-grow-0 py-2 px-4 rounded-lg text-white font-semibold text-center transition-all duration-300 shadow-sm";
    const enabledClasses = "bg-red-500 hover:bg-red-600 hover:shadow-md";
    const disabledClasses = "bg-red-300 cursor-not-allowed opacity-70";

    return (
        <Link
            to={isEnabled ? to : "#"}
            className={`${baseClasses} ${isEnabled ? enabledClasses : disabledClasses}`}
            target={isEnabled && to !== '#' ? "_blank" : "_self"}
            rel={isEnabled && to !== '#' ? "noopener noreferrer" : ""}
            // Prevent click event on disabled links for better accessibility
            onClick={(e) => !isEnabled && e.preventDefault()}
        >
            {children} {!isEnabled && "(NA)"}
        </Link>
    );
};

const ensureHasProtocol = (url) => {
    // If the URL is null, undefined, or empty, return a non-clickable link.
    if (!url) return "#";

    // If it already has a protocol, return it as is.
    if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
    }

    // Otherwise, prepend "https://" (safer default than http).
    return `https://${url}`;
};

const EditEmployerProfile1 = () => {
    // 1. Get the ID from the URL. It will be undefined if no ID is present (e.g., /employers/new).
    const { id } = useParams();

    // 2. Fetch employer data only if an 'id' exists in the URL.
    //    - The `skip: !id` option prevents the query from running on "create" pages.
    //    - Renamed `data` to `employerData` for clarity.
    const {
        data: employerData,
        isLoading: isEmployerLoading,
        isSuccess: isEmployerSuccess,
        isError: isEmployerError,
    } = useGetEmployerQuery(id, {
        skip: !id,
    });



    // Handle case where an ID was provided but no data was found
    if (id && isEmployerSuccess && !employerData) {
        return <div className="p-8 text-center text-orange-500 font-semibold">Employer with ID '{id}' not found.</div>;
    }

    // 3. The `employer` prop passed to the form now comes directly from our API call.
    //    - In "create" mode (no id), `employerData` will be `undefined`, which correctly puts EmployerAddEdit in "add mode".
    const employer = employerData;


    console.log(employer);
    const isEditMode = !!id; // A clear flag for whether we are editing or creating

    return (
        <div className="mx-auto bg-white rounded-2xl overflow-hidden">
            {/* Header Section */}
            <div className="p-6 border-gray-200">
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
                    {/* Left side: Logo, Company Name, and Meta Info */}
                    <div className="flex-grow"> {/* Use flex-grow to take available space */}
                        <div className="flex items-center gap-5">
                            {isEditMode && (
                                <div className="flex-shrink-0 w-24 h-24 bg-white border border-gray-200 rounded-xl grid place-items-center p-1">
                                    <img
                                        src={
                                            employer?.logo
                                                ? `https://academicjobs.s3.amazonaws.com/img/university-logo/${employer.logo}`
                                                : "/favicon.png"
                                        }
                                        alt={`${employer?.company_name} logo`}
                                        className="object-contain w-full h-full"
                                    />
                                </div>
                            )}
                            <div className="flex-grow">
                                <h1 className="text-2xl md:text-4xl font-bold text-gray-800">
                                    {isEditMode ? employer?.company_name : 'Create New Employer Profile'}
                                </h1>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Quick Actions Section (only show in edit mode, as links depend on employer data) */}
            {isEditMode && (
                <div className="p-6">
                    <div className="flex flex-wrap gap-3">
                        <ActionLink to={`https://www.teachingjobs.com.au/employers/${employer?.company_name?.replace(/\W+/g, "-").toLowerCase()}/${employer?.id}/`} isEnabled={!!employer?.id}>
                            View Live Profile
                        </ActionLink>
                        <ActionLink to={ensureHasProtocol(employer?.website)} isEnabled={true}>
                            Employer Website
                        </ActionLink>
                        <ActionLink to={ensureHasProtocol(employer?.employerPageURL)} isEnabled={!!employer?.employerPageURL}>
                            Job Page URL
                        </ActionLink>
                        <ActionLink to={ensureHasProtocol(employer?.contactPageURL)} isEnabled={!!employer?.contactPageURL}>
                            Staff Directory
                        </ActionLink>
                        <Link className="flex-grow sm:flex-grow-0 py-2 px-4 rounded-lg text-white font-semibold text-center transition-all duration-300 shadow-sm bg-red-500 hover:bg-red-600 hover:shadow-md" to="/post-a-job/">
                            Post a Job
                        </Link>
                    </div>
                </div>
            )}


            {/* The form component now receives the fetched `employer` data */}
            <div className="p-6 border-t border-gray-200">
                <EmployerAddEdit employer={employer} />
            </div>
        </div>
    );
};

export default EditEmployerProfile1;